








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AuthLayout extends Vue {

  protected image: string = '/img/login.jpg';
  protected sidebarOverlayGradiant: string = 'rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)';

}

